import API_PATH from '@/constants/apiPath'
import Toastr from 'toastr'

const state = {
}
const getters = {
}
const mutations = {

}
const actions = {
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
